"use client";

import React from "react";
import { Loader } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
function AiEdgeForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="w-full max-w-md mx-auto text-center p-8 bg-white/5 border border-white/10 rounded-xl backdrop-blur-sm animate-in fade-in zoom-in duration-500">
        <h3 className="text-2xl font-bold text-white mb-2">You're on the list!</h3>
        <p className="text-white/80">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="w-full max-w-2xl mx-auto space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-end">
        {}
        <FormField name="first_name" rules={{
        required: "Name is required"
      }} render={({
        field
      }) => <FormItem className="space-y-0">
              <FormLabel className="sr-only">First Name</FormLabel>
              <FormControl>
                <Input placeholder="First Name" {...field} className="border-0 border-b border-white/30 bg-transparent px-0 py-2 text-white placeholder:text-white/50 focus-visible:border-white focus-visible:ring-0 rounded-none shadow-none h-auto text-lg transition-colors" />
              </FormControl>
              <FormMessage className="text-red-400 text-xs mt-1 absolute" />
            </FormItem>} />

        {}
        <FormField name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email address"
        }
      }} render={({
        field
      }) => <FormItem className="space-y-0">
              <FormLabel className="sr-only">Email Address</FormLabel>
              <FormControl>
                <Input type="email" placeholder="Email Address" {...field} className="border-0 border-b border-white/30 bg-transparent px-0 py-2 text-white placeholder:text-white/50 focus-visible:border-white focus-visible:ring-0 rounded-none shadow-none h-auto text-lg transition-colors" />
              </FormControl>
              <FormMessage className="text-red-400 text-xs mt-1 absolute" />
            </FormItem>} />

        {}
        <FormField name="interest_area" render={({
        field
      }) => <FormItem className="space-y-0">
              <FormLabel className="sr-only">Interest Area</FormLabel>
              <FormControl>
                <select {...field} className="w-full border-0 border-b border-white/30 bg-transparent px-0 py-2 text-white/50 focus:text-white focus:border-white focus:ring-0 rounded-none shadow-none h-auto text-lg transition-colors appearance-none cursor-pointer [&>option]:text-black" defaultValue="">
                  <option value="" disabled hidden>
                    Select Interest
                  </option>
                  <option value="AI Writing Tools">AI Writing Tools</option>
                  <option value="AI Video Creation">AI Video Creation</option>
                  <option value="AI Design & Imaging">AI Design & Imaging</option>
                  <option value="AI Marketing Automation">AI Marketing Automation</option>
                  <option value="All of the above">All of the above</option>
                </select>
              </FormControl>
              <FormMessage className="text-red-400 text-xs mt-1 absolute" />
            </FormItem>} />
      </div>

      <div className="flex flex-col items-center gap-4 pt-4">
        <Button type="submit" disabled={isSubmitting} className="rounded-full bg-white text-black hover:bg-white/90 px-10 py-6 text-lg font-semibold min-w-[200px] shadow-[0_0_20px_rgba(255,255,255,0.3)] hover:shadow-[0_0_30px_rgba(255,255,255,0.5)] transition-all duration-300">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-5" />
              Joining...
            </> : "Subscribe"}
        </Button>
        
        {submitError && <p className="text-red-400 text-sm bg-red-950/30 px-4 py-2 rounded-md border border-red-900/50">
            {submitError}
          </p>}
        
        <p className="text-white/40 text-sm font-light tracking-wide">
          No spam. Just the tools you need.
        </p>
      </div>
    </Form>;
}
export default function GetTheAiEdge() {
  return <section id="get-the-ai-edge" className="dark bg-background text-foreground relative w-full py-24 md:py-32 overflow-hidden flex items-center justify-center min-h-[600px]">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-secondary)_0%,transparent_60%)] opacity-20 blur-3xl transform scale-150" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,var(--color-primary)_0%,transparent_50%)] opacity-10 blur-3xl" />
        <div className="absolute inset-0 bg-black/40" />
      </div>

      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center justify-center text-center">
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tighter text-white mb-12 drop-shadow-2xl">
          STAY AHEAD OF THE CURVE
        </h2>

        <FormProvider formId="ai_edge_form_home" sectionName="get-the-ai-edge" defaultValues={{
        first_name: "",
        email: "",
        interest_area: ""
      }} validationRules={{
        first_name: {
          required: true
        },
        email: {
          required: true,
          pattern: "email"
        }
      }} submitText="Subscribe" successMessage="Welcome to the future. Check your inbox for your first insight.">
          <AiEdgeForm />
        </FormProvider>
      </div>
    </section>;
}